import type { AxiosResponse } from 'axios';
import { t } from 'i18next';

/**
 * 用来判断请求成功还是失败 返回错误信息，则为失败
 * assert-response
 * @param response
 */
export function assertResponse(response: AxiosResponse): string | null {
  if (response.data?.statusCode === '000000') return null;
  return response.data?.message || t('common:system_busy');
}
